import screenerActionTypes from '../actionTypes/screener.actionTypes'
import { ActionType } from './common.reducer'
import {
    GlobalScreenerColumn,
    GlobalScreenerColumnSet,
    ScanScreenerResponse,
    ScreenerField,
} from '../proto/generated/screener'

interface ScreenerStateType {
    globalColumns: GlobalScreenerColumn[];
    columnSets: GlobalScreenerColumnSet[];
    fields: ScreenerField[];
    securities: ScanScreenerResponse;
}

const initialState: ScreenerStateType = {
    globalColumns: [],
    columnSets: [],
    fields: [],
    securities: {
        data: [],
        totalCount: 0
    },
}

export default function screenerReducer(state = initialState, action: ActionType) {
    const { type, payload } = action

    switch (type) {
        case screenerActionTypes.SAVE_SCREENER_COLUMNS:
            return {
                ...state,
                globalColumns: payload
            }
        case screenerActionTypes.SAVE_SCREENER_COLUMN_SETS:
            return {
                ...state,
                columnSets: payload
            }
        case screenerActionTypes.SCAN_SECURITIES:
            return {
                ...state,
                securities: payload
            }
        case screenerActionTypes.SAVE_SCREENER_FIELDS:
            return {
                ...state,
                fields: payload
            }
        default:
            return state
    }
}
